export default __webpack_public_path__ + "static/media/step3.49f4568a.svg";